import PropTypes from 'prop-types';

export const ReturnReasonPropType = PropTypes.shape({
  returnReasonId: PropTypes.string,
  name: PropTypes.string,
});

/**
 * @typedef {object} ReturnReasonPropType
 * @property {string} returnReasonId
 * @property {string} name
 */
